import { __awaiter, __generator } from "tslib";
import { sliderKey } from '.';
import { Simulate } from 'react-dom/test-utils';
var keyPressEvents = {
    right: { key: 'ArrowRight', keyCode: 39, which: 39 },
    left: { key: 'ArrowLeft', keyCode: 37, which: 37 }
};
export var createSliderDriver = function (wrapper) {
    var base = wrapper.$("." + sliderKey);
    var step = function (side) { return function (index) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = Simulate).click;
                    return [4 /*yield*/, base.$$(".slider-handles>.slider-handle>button").get(index).getNative()];
                case 1:
                    _b.apply(_a, [_e.sent()]);
                    _d = (_c = Simulate).keyDown;
                    return [4 /*yield*/, base.$$(".slider-handles>.slider-handle>button").get(index).getNative()];
                case 2:
                    _d.apply(_c, [_e.sent(), side]);
                    return [2 /*return*/];
            }
        });
    }); }; }; };
    var getHandle = function (index) {
        return {
            stepRight: step(keyPressEvents.right)(index),
            stepLeft: step(keyPressEvents.left)(index),
            value: function () { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = Number;
                        return [4 /*yield*/, base.$$(".slider-handles>.slider-handle>[role='slider']div").get(index).attr('aria-valuenow')];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            }); }); }
        };
    };
    var getValues = function () { return base
        .$$(".slider-handles>.slider-handle>div[role='slider']")
        .map(function (item) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = Number;
                return [4 /*yield*/, item.attr('aria-valuenow')];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    }); }); }); };
    return {
        getHandle: getHandle,
        getValues: getValues,
        base: base
    };
};
//# sourceMappingURL=driver.js.map